import styled from 'styled-components';

export const Header = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 0 20px;
    margin-bottom: 8px;

    .logo {
        height: 44px;
        width: auto;
        max-width: 70%;
        object-fit: contain;
    }
    .back {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: none;
        border: none;
        cursor: pointer;
        color: #5b5bd6;
        font-size: 18px;
        line-height: 1;
        padding: 8px;
    }
`;

export const Warn = styled.div`
    background: #fff8e1;
    border: 1px solid #ffe082;
    color: #8a6d00;
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 13px;
    margin: 8px 0 16px;
`;

export const Help = styled.p`
    display: none;
    font-size: 13px;
    line-height: 1.5;
    color: #666;
    background: #f5f6fa;
    border-radius: 8px;
    padding: 12px 14px;
    margin: 16px 0 8px;

    a {
        color: #5b5bd6;
        font-weight: 600;
    }
`;

export const LinkRow = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-top: 12px;

    button {
        background: none;
        border: none;
        color: #5b5bd6;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        padding: 4px;
    }
`;

export const Loading = styled.div`
    text-align: center;
    color: #888;
    padding: 48px 0;
    font-size: 14px;
`;

export const ErrorBox = styled.div`
    text-align: center;
    padding: 40px 0;

    p {
        color: #c0392b;
        margin-bottom: 12px;
    }
    button {
        background: #5b5bd6;
        color: #fff;
        border: none;
        border-radius: 8px;
        padding: 10px 18px;
        font-size: 14px;
        cursor: pointer;
    }
`;

export const Section = styled.section`
    margin: 24px 0;
`;

export const SectionHead = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    background: none;
    border: none;
    cursor: ${p => (p.collapsible ? 'pointer' : 'default')};
    padding: 0 0 12px;
    text-align: left;

    h3 {
        font-size: 16px;
        font-weight: 700;
        color: #1a1a2e;
        margin: 0;
    }
    .chevron {
        margin-left: auto;
        color: #999;
        transition: transform 0.2s;
        transform: rotate(${p => (p.open ? '180deg' : '0deg')});
    }
`;

export const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    padding: 0 7px;
    border-radius: 11px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    background: ${p => (p.alert ? '#e8590c' : '#9aa0b5')};
`;

export const Empty = styled.div`
    color: #999;
    font-size: 14px;
    padding: 8px 0 16px;
`;

export const Card = styled.div`
    border: 1px solid #ebecf2;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 12px;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
`;

export const CardHead = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;

    .logo {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        object-fit: contain;
        background: #f0f1f5;
        flex: 0 0 auto;
    }
    .who {
        min-width: 0;
    }
    .org {
        font-weight: 700;
        font-size: 15px;
        color: #1a1a2e;
    }
    .vs {
        font-size: 12px;
        color: #999;
    }
`;

export const StatusBadge = styled.span`
    display: inline-block;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 700;
    margin-left: auto;
    color: ${p =>
        p.kind === 'confirmed' ? '#1b7a3d' : p.kind === 'rejected' ? '#b02a2a' : '#8a6d00'};
    background: ${p =>
        p.kind === 'confirmed' ? '#e6f4ea' : p.kind === 'rejected' ? '#fbe9e9' : '#fff8e1'};
`;

export const Row = styled.div`
    display: flex;
    gap: 10px;
    padding: 5px 0;
    font-size: 13px;
    border-top: 1px solid #f4f5f7;

    .label {
        color: #888;
        flex: 0 0 38%;
    }
    .value {
        color: #333;
        font-weight: 500;
    }
`;

export const Actions = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 14px;

    button {
        flex: 1;
        border: none;
        border-radius: 8px;
        padding: 10px;
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
    }
    .validate {
        background: #1b7a3d;
        color: #fff;
    }
    .reject {
        background: #fff;
        color: #b02a2a;
        border: 1px solid #e7b8b8;
    }
    .confirm {
        background: #5b5bd6;
        color: #fff;
    }
    .cancel {
        background: #f0f1f5;
        color: #555;
    }
`;

export const ConfirmText = styled.div`
    font-size: 13px;
    color: #555;
    margin-top: 14px;
    margin-bottom: 6px;
    font-weight: 600;
`;

export const RegisterBtn = styled.a`
    display: block;
    text-align: center;
    background: #5b5bd6;
    color: #fff !important;
    border-radius: 10px;
    padding: 14px;
    font-size: 15px;
    font-weight: 700;
    text-decoration: none;
    margin: 28px 0 12px;
`;
